// extracted by mini-css-extract-plugin
module.exports = {"text":"title-module--text--2DwAx"};